module.exports = __webpack_public_path__ + "img/audepom-vignette.76387ee.jpg";